import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    SGA_GET_ZONAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.get.zonas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_ZONAS_ASIENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.zonas.asientos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_CREATE : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.create'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_GUARDAR_DATOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.guardar-datos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_GUARDAR_CONDICIONES : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.guardar-condiciones'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_ELIMINAR_DATOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.eliminar-datos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_GET_DESCUENTOS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.get.descuentos'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_SOLICITAR_COBRO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.solicitar-cobro'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_RESUMEN : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.resumen'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_BUSCAR_ABONO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.buscar.abono'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },

    SGA_PROFILE_EVENTOS_CESION : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.eventos-cesion'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_PROFILE_ABONO_ENTRADAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abono.entradas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_EVENTO_CEDER : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.evento.ceder'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_EVENTO_RECUPERAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.evento.recuperar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_DESCUENTOS_CODIGO : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.descuentos-codigo'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    SGA_CART_DESCUENTOS_CODIGO_GUARDAR : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.cart.descuentos-codigo.guardar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },    
    SGA_PROFILE_ABONO_CESION_BENEFITS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('sga.profile.abono.cesion.benefits'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
}

export default {
    actions
};